import { withInstall } from '../../utils/install';
import CarouselItem from './index.vue';

export const IvueCarouselItem = withInstall(CarouselItem);
export default IvueCarouselItem;

export * from './index.vue';
